module.exports = __webpack_public_path__ + "static/load-9d89a7727840686a45bd96951e46063a.svg";